import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import SEO from "@/components/SEO";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen cg-pink-bg flex items-center justify-center px-4" data-testid="not-found-page">
      <SEO title="Page Not Found, Corona Gas" />
      <div className="text-center max-w-md">
        <div className="font-[Manrope] font-extrabold text-[#E50914] text-8xl mb-4">404</div>
        <h1 className="font-[Manrope] font-bold text-[#0F0F0F] text-2xl mb-3">
          Page not found
        </h1>
        <p className="text-[#475569] mb-6">
          The page you're looking for has been moved or doesn't exist.
        </p>
        <Link to="/" className="btn-coral">
          <Home className="w-4 h-4" />
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
